// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__hZX_8","inputWrap":"styles_inputWrap__2uBn4","input":"styles_input__2ABeL"};